import React from "react";
import PropTypes from "prop-types";
import { Box, Chip } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import StorageIcon from "@mui/icons-material/Storage";

// Entry-wide file count/total-size chips shown near the attachment list. Per-field inline-
// image counts are shown separately (RichTextEditorField.js's metricsFooter) — the
// entry-wide image-count chip was removed (unreliable across the paste/save/reload
// lifecycle); imageCount/imageSizeBytes are accepted but no longer read.
const formatBytes = (bytes) => {
  if (!bytes) return "0 KB";
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export default function DTRAttachmentSummary({ fileCount = 0, fileSizeBytes = 0 }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        alignItems: "center",
        mb: 1,
      }}
    >
      <Chip
        size="small"
        icon={<AttachFileIcon fontSize="small" />}
        label={`${fileCount} file${fileCount === 1 ? "" : "s"}`}
        sx={{ backgroundColor: "#EEF6FF", color: "#3299FF", fontWeight: 600 }}
      />
      <Chip
        size="small"
        icon={<StorageIcon fontSize="small" />}
        label={`${formatBytes(fileSizeBytes)} total`}
        sx={{ backgroundColor: "#F5F5F5", color: "#555", fontWeight: 600 }}
      />
    </Box>
  );
}

DTRAttachmentSummary.propTypes = {
  fileCount: PropTypes.number,
  fileSizeBytes: PropTypes.number,
  // No longer read — kept optional so existing callers don't trigger a PropTypes warning.
  imageCount: PropTypes.number,
  imageSizeBytes: PropTypes.number,
};
